import { Box, Button, Typography, useTheme } from '@mui/material';
import { ArrowOutward, Navigation } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const InsuranceTypeBox = ({ insuranceType }) => {
  const { imageUrl, header, title, text, buttonText, url } = insuranceType;
  const navigate = useNavigate();

  const clickHandler = () => {
    navigate(url);
  };

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flexDirection: 'column',
        borderRadius: `${theme.spacingValues.medium}`,
        backgroundColor: `${theme.palette.primary.contrastText}`,
        padding: `${theme.spacingValues.mediumLarge}`,
        width: { xs: '100%', sm: '630px' },
      }}
    >
      <Box
        component="img"
        src={imageUrl}
        alt={title}
        sx={{
          borderRadius: `${theme.spacingValues.medium}`,
          width: '100%',
          height: '138px',
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
      <Box
        borderRadius={'25px'}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: `${theme.spacingValues.medium}`,
          backgroundColor: `${theme.palette.grey[50]}`,
          padding: `${theme.spacingValues.small} ${theme.spacingValues.mediumLarge}`,
          marginTop: `${theme.spacingValues.medium}`,
        }}
      >
        <Navigation
          sx={{
            transform: 'rotate(45deg)',
            color: `${theme.palette.primary.main}`,
          }}
        />
        <Typography
          variant="body1"
          sx={{
            color: `${theme.palette.primary.main}`,
          }}
        >
          Seguro viagem para
        </Typography>
      </Box>
      <Typography
        variant="h2"
        sx={{
          marginTop: `${theme.spacingValues.medium}`,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginTop: `${theme.spacingValues.medium}`,
        }}
      >
        {text}
      </Typography>
      <Button
        variant="contained"
        sx={{
          marginTop: `${theme.spacingValues.medium}`,
          backgroundColor: `${theme.palette.primary.main}`,
          color: `${theme.palette.primary.contrastText}`,
          '&:hover': {
            backgroundColor: `${theme.palette.primary.dark}`,
          },
        }}
        onClick={clickHandler}
        endIcon={<ArrowOutward />}
      >
        Clique e saiba mais
      </Button>
    </Box>
  );
};

export default InsuranceTypeBox;
